import my_projects from "../../data/projects.js";

export function GetProjects() {
    return my_projects
}